import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { NothingToSee } from 'components/shared';
import MenuDetails from 'components/menu/MenusPage/components/MenuDetails';
import { MenusPage } from 'components/menu/MenusPage';
import { OrdersPage } from 'components/orders';
import Transactions from 'components/restaurantInformation/transactions';
import Home from 'components/home';
import Callback from 'components/callback/Callback';
import silentRenew from 'components/silent-renew';
import Reservations from 'components/reservations';
import NewReservationPage from 'components/reservations/NewReservationPage';
import ProcessRequestPage from 'components/reservations/ProcessRequestPage';
import EditReservationPage from 'components/reservations/EditReservationPage';
import { RESERVATION_POSITIONS } from 'helpers/reservationHelper';
import PositionRoute from './components/positionRoute';

export const RestaurantEmployeeRoute: React.FC<{}> = () => {
    return (
        <Switch>
            <Route exact path="/" component={Home} />
            <Route exact path="/orders" component={OrdersPage} />;
            <Route exact path="/menu" component={MenusPage} />
            <Route exact path="/menu/:id" component={MenuDetails} />
            <Route exact path="/callback" component={Callback} />
            <Route exact path="/silentRenew" component={silentRenew} />
            <Route exact path="/transactions" component={Transactions} />
            <PositionRoute
                exact
                path="/reservations"
                positions={RESERVATION_POSITIONS}
                component={Reservations}
            />
            <PositionRoute
                exact
                path="/reservations/new"
                positions={RESERVATION_POSITIONS}
                component={NewReservationPage}
            />
            <PositionRoute
                exact
                path="/reservations/requests/:id/process"
                positions={RESERVATION_POSITIONS}
                component={ProcessRequestPage}
            />
            <PositionRoute
                exact
                path="/reservations/:id/edit"
                positions={RESERVATION_POSITIONS}
                component={EditReservationPage}
            />
            <Route component={NothingToSee} />
        </Switch>
    );
};
